import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { layoutConsts } from "theme";
import clsx from "clsx";

const useStyles = (amount: number) =>
    makeStyles((theme: Theme) => {
        return createStyles({
            root: {
                transform: `rotate(${amount}deg)`,
            },
        });
    });

type IClasses = Partial<ReturnType<ReturnType<typeof useStyles>>>;

export interface IRotateProps extends React.HTMLAttributes<HTMLDivElement> {
    amount: number;
    classes?: IClasses;
}

export default function Rotate(props: IRotateProps) {
    const {
        amount = layoutConsts.defaultTiltDegrees,
        classes: overrideClasses,
        children,
        className,
        ...rest
    } = props;
    const classes = useStyles(amount)();

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            {children}
        </div>
    );
}
